module.exports = __webpack_public_path__ + "static/dining-1-opt-834d6b03ff6a1f1ad401e21c22bb537d.jpg";